import { render, staticRenderFns } from "./test-view.vue?vue&type=template&id=22f72bfc&scoped=true"
import script from "./test-view.vue?vue&type=script&lang=ts"
export * from "./test-view.vue?vue&type=script&lang=ts"
import style0 from "./test-view.vue?vue&type=style&index=0&id=22f72bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f72bfc",
  null
  
)

export default component.exports